import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  InstallGallery,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const Vms = () => {
  const installColumns = [
    {
      label: '주간',
      images: [
        '/images/products/guardrail/VMS7.jpg',
      ],
    },
    {
      label: '야간',
      images: [
        '/images/products/guardrail/VMS3.jpg',
      ],
    },
  ];

  const features = [
    {
      title: '야간 가시성 극대화',
      bullets: [
      {
        label: (
          <>문형식 VMS 구조물 주변에 LED 조명을 적용하여 표지판 정보를 명확하게 전달</>
        ),
      },
      {
        label: (
          <>조도 확보가 어려운 야간·우천·악천후 상황에서도 선명한 메시지 제공</>
        ),
      },
      {
        label: (
          <>운전자의 시야 확보를 지원해 정보 인지 실패로 인한 사고 위험 감소</>
        ),
      },
      ]
    },
    {
      title: '고효율 LED 기반 에너지 절감',
      bullets: [
      {
        label: (
          <>저전력 고효율 LED 광원을 사용해 운영비 절감</>
        ),
      },
      {
        label: (
          <>장수명 모듈 적용으로 유지관리 비용 및 교체 주기 감소</>
        ),
      },
      {
        label: (
          <>균일한 조도 설계로 에너지 대비 최대의 시인성 효과 확보</>
        ),
      },
      ]
    },
    {
      title: '안정적이고 견고한 구조 설계',
      bullets: [
      {
        label: (
          <>고속도로 환경의 진동·바람·오염 등을 고려한 내구성 높은 설계</>
        ),
      },
      {
        label: (
          <>방수·방진 성능을 갖춘 조명 모듈로 장기간 안정적 운용 가능</>
        ),
      },
      {
        label: (
          <>구조물과 자연스럽게 일체화되는 디자인으로 주변 환경과의 조화성 확보</>
        ),
      },
      ]
    },
    {
      title: '설치 및 유지보수 편의성 강화',
      bullets: [
      {
        label: (
          <>다양한 VMS 설치 형태에 대응 가능한 모듈형 구조</>
        ),
      },
      {
        label: (
          <>유지보수 작업자가 쉽게 접근할 수 있도록 고려한 배치</>
        ),
      },
      {
        label: (
          <>점검 및 부품 교체가 간편해 운영 효율성 향상</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`VMS 조명시설`}
        subtitle={`다양한 실시간 정보를 전달하여 \n고속도로 흐름을 안정화시킵니다`}
        backgroundImage="/images/products/guardrail/VMS7.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: 'VMS 조명시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`실시간 정보로 안전성 제고`}
        title={`VMS 조명시설`}
        description={
          <>
            VMS(Variable Message Sign, 가변 메시지 표지판) 조명시설은 도로 이용자에게 <strong>교통 상황, 도로 및 기상 정보, 공사 통제 현황 등 다양한 실시간 정보를 전달</strong>하는 핵심 안전시설물로써, {' '}
            고속도로의 <strong>교통 흐름 효율화, 긴급 상황 대응력 강화, 운전자 안전성 제고</strong>에 크게 기여합니다.

            <br />
            <br />
            기존 문형식 VMS 구조물에 <strong>고효율 LED 기반 야간 조명 기능을 추가</strong>하여, {' '}
            운전자가 정보판을 <strong>더 선명하고 안정적으로 인지할 수 있도록 시인성과 가시성을 획기적으로 향상</strong>시킵니다.
          </>
        }
        images={[
          '/images/products/guardrail/VMS2.jpg',
          '/images/products/guardrail/VMS3.jpg',
          '/images/products/guardrail/VMS4.jpg',
          '/images/products/guardrail/VMS5.jpg',
          '/images/products/guardrail/VMS6.webp',
          '/images/products/guardrail/VMS7.jpg',

        ]}
      />

      <SectionDivider />

      <InfoSection title="설치 사진">
        <InstallGallery columns={installColumns} />
      </InfoSection>


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/VMS"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default Vms;
